import React, { useState } from "react";
import ReactQuill from "react-quill";
import TextButton from "../General/TextButton";

function ExpandableReactQuill({ text, dataId, minTextLength }) {
    const [expandedRows, setExpandedRows] = useState([]);

    const toggleRow = (rowId) => {
        if (expandedRows.includes(rowId)) {
            setExpandedRows(expandedRows.filter((id) => id !== rowId));
        } else {
            setExpandedRows([...expandedRows, rowId]);
        }
    };

    const renderLongText = (longtext, rowId) => {
        const words = longtext.split(' ');
        if (expandedRows.includes(rowId)) {
            return longtext;
        } else {
            // return longtext.slice(0, 150) + "(...)";
            const slicedWords = words.slice(0, 20);
            return slicedWords.join(' ') + (words.length > 20 ? " (...)" : "");
        }
    };

    return (
        <React.Fragment>
            <ReactQuill
                theme="bubble"
                value={renderLongText(text, dataId)}
                style={{ marginBottom: ".5rem" }}
                readOnly
            />
            {
                text.length >= minTextLength && (
                    <TextButton onClick={() => toggleRow(dataId)}>
                        {expandedRows.includes(dataId) ? "Read Less" : "Read More"}
                    </TextButton>
                )
            }
        </React.Fragment>
    );
}

export default ExpandableReactQuill;
